import _ from 'lodash'

import {Router} from './services/router/router'

import {
    ACTIVATE_LEG,
    activateLeg
} from './leg/leg.action'

import {
    CHANGE_DETAILS_UI,
    onChangeDetailsUI,
    ACTIVATE_ACCOMMODATION,
    activateAccommodation,
    ACTIVATE_ACTIVITY,
    activateActivity,
    ACTIVATE_ACTIVITY_BY_ID,
    activateActivityById,
    activateAccommodationById
} from './details/details.action'

export const ROUTE_TYPES = {
    ITINERARY: 'itinerary',
    UISTATUS: 'uistatus',
    LEG: 'leg',
    ACCOMMODATION: 'accommodation',
    ACTIVITY: 'activity',
}

// the routes object binds the type (what shows up in the link) to a function that
// tells redux how to display it
export const routes = {
    [ROUTE_TYPES.LEG]: function(store, segment) {
        let state = store.getState()

        let leg = state.getIn(['document', 'legs']).find((leg) => {
            return leg.get('id') === segment.identifier
        })

        if (!leg) {
            // this is like a 404? not sure how to handle this yet
            return
        }
        // check to make sure the leg isn't already active?
        if (state.getIn(['uiState', 'activeLeg']) !== leg.get('id')) {      
            store.dispatch(activateLeg(leg))
        }
    },

    [ROUTE_TYPES.UISTATUS]: function(store, segment) {
        let state = store.getState()
        let uiPieces = _.split((segment.identifier).toUpperCase(), '~')
        store.dispatch(onChangeDetailsUI(uiPieces[0], uiPieces[1]))
    },

    [ROUTE_TYPES.ACCOMMODATION]: function(store, segment) {
        let state = store.getState()
        let accom = null
        let leg = state.getIn(['document', 'legs']).find((leg) => {
            let accoms = leg.getIn(['accommodations'])
            accom = accoms.find((accom) => {
                return accom.get('accommodation_guid') === segment.identifier
            })
            if (accom) {
                return leg
            }
        })
        if (!leg) {
            store.dispatch(activateAccommodationById(segment.identifier))      
        } else {
            // just trigger the leg
            // store.dispatch(activateLeg(leg))    
            if (accom) {
                store.dispatch(activateAccommodation(accom))
                // store.dispatch(onChangeDetailsUI('ACCOMMODATIONS','DETAILS'))
            } else {
                // fall back if accommodation isn't there
                store.dispatch(onChangeDetailsUI('ACCOMMODATIONS', 'OVERVIEW'))
            }
        }
    },

    [ROUTE_TYPES.ACTIVITY]: function(store, segment) {
        let state = store.getState()
        let act = null
        let leg = state.getIn(['document', 'legs']).find((leg) => {
            let acts = leg.getIn(['activities'])
            act = acts.find((act) => {
                return act.get('place_id') === segment.identifier
            })
            if (act) {
                return leg
            }
        })
        if (!leg) {
            // lets pass just the id and sort it out on the other end
            store.dispatch(activateActivityById(segment.identifier))
            // return
        }
        // just trigger the leg
        // store.dispatch(activateLeg(leg))
        if (act) {
            store.dispatch(activateActivity(act))
            // store.dispatch(onChangeDetailsUI('ACTIVITIES','DETAILS'))
        }
    }
}
